import { Country } from "../models/country-viewmodel";
import { ICountry } from "../models/country-model";

export default class CountryMapper {
    public mapCountries(items: ICountry[]): Country[] {
        return items.map(item => this.mapCountry(item));
    }

    public mapCountry(item: ICountry): Country {
        return new Country(
            item.isoCode,
            item.name,
            item.nationality,
            item.countryCode
        );
    }
}